<template>
  <div>
    <div class="flex">
      <AdminPanel>
        <h1 class="mb-4">Add New User</h1>
        <div>
          <div class="mx-4 flex flex-col">
            <TextInput ref="firstname" class="mb-4" placeholder="First Name"></TextInput>
            <TextInput ref="lastname" class="mb-4" placeholder="Last Name"></TextInput>
            <TextInput ref="email" class="mb-4" placeholder="E-Mail Address"></TextInput>
            <TextInput ref="password" class="mb-8" placeholder="Password"></TextInput>
            <RadioGroup ref="tierSelector" :options="tierOptions"></RadioGroup>
            <div class="flex items-center w-full text-center justify-center">
              <JButton @click="add" label="Create" :isWhite="false"></JButton>
            </div>
          </div>
          <div v-show="message" class="mt-4 text-center text-green-dark">
            {{ message }}
          </div>
        </div>
      </AdminPanel>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import TextInput from '@/components/TextInput'
import JButton from '@/components/JButton'
import RadioGroup from '@/components/RadioGroup'
import AdminPanel from '@/components/AdminPanel'

export default {
  name: 'AddNewUser',
  components: { TextInput, JButton, AdminPanel, RadioGroup },
  data () {
    return {
      message: ``,
      tierOptions: [
        {
          name: 'tier1',
          label: 'Tier 1'
        },
        {
          name: 'tier2',
          label: 'Tier 2'
        },
        {
          name: 'tier3',
          label: 'Tier 3'
        }
      ]
    }
  },
  methods: {
    async add () {
      this.message = ''
      const email = this.$refs.email.getValue()
      const firstname = this.$refs.firstname.getValue()
      const lastname = this.$refs.lastname.getValue()
      const password = this.$refs.password.getValue()
      const tier = this.$refs.tierSelector.getSelectedOption()

      // create firebase user
      const createdUserData = await firebase.auth().createUserWithEmailAndPassword(email, password)

      // store basic user info
      await firebase.firestore().doc(`users/${createdUserData.user.uid}`).set({
        firstname,
        lastname,
        tier: tier.name
      })

      this.message = `User ${email} has been created.`
    }
  }
}
</script>
